// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__1VWcy","label":"Category_label__2ZqRS","content":"Category_content__nUgi4","header":"Category_header__1vzau","location":"Category_location__1mVO3"};